import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputSelectComponent } from './input-select.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { PipesModule } from 'src/app/core/pipes/pipes.module';

@NgModule({
  declarations: [InputSelectComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, SharedModule, PipesModule],
  exports: [InputSelectComponent]
})
export class InputSelectModule {}
